import { PRIMARY_TEXT } from 'constants/colors'
import styled from 'styled-components'

export const ImageContainer = styled.div<{
  maxHeight: string
  maxWidth: string
}>`
  > img {
    max-height: ${({ maxHeight }) => maxHeight};
    max-width: ${({ maxWidth }) => maxWidth};
  }
`

export const IconButtonContainer = styled.div`
  margin-left: 14px;

  .MuiButtonBase-root.MuiIconButton-root svg {
    fill: none;
    stroke: ${PRIMARY_TEXT};
  }
`
